import { useCartStore } from '../../../../../../context/cart/CartStore';
import DiscountDialog from '../../../../../../components/DiscountDialog/DiscountDialog';

type CartDiscountDialogProps = {
  onClose: () => void;
};

const CartDiscountDialog = (props: CartDiscountDialogProps) => {
  const { onClose } = props;
  const { appliedDiscount, setAppliedDiscount } = useCartStore((state) => ({
    appliedDiscount: state.appliedDiscount,
    setAppliedDiscount: state.applyDiscount,
  }));

  return <DiscountDialog appliedDiscount={appliedDiscount} onApplyDiscount={setAppliedDiscount} onClose={onClose} />;
};

export default CartDiscountDialog;
